<template>
  <div>
    <Head title="Edit Job" />
    <v-container class="grey lighten-5">
      <v-card>
        <v-card-title>
          <span class="text-h4">Edit Job</span>
          <v-spacer></v-spacer>
           <Link href="/admin/jobs" class="text-decoration-none">
    <v-btn color="primary">
      <v-icon left>mdi-arrow-left</v-icon>
      Back to Jobs
    </v-btn>
  </Link>
        </v-card-title>
        
        <v-card-text>
          <v-container v-if="errors">
            <v-row>
              <v-col cols="12" md="12">
                <v-alert type="error">
                  <ul>
                    <li v-for="e in errors" :key="e">
                      {{ e[0] }}
                    </li>
                  </ul>
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
          
          <!-- Add this inside v-card-text after the errors container -->
<v-container>
  <v-row>
    <v-col cols="12" sm="12">
      <p class="text-h4">Basic Information</p>
    </v-col>
    
    <v-col cols="12" sm="12" md="6">
      <v-switch v-model="job.status" label="Active"></v-switch>
    </v-col>
    
    <v-col cols="12" sm="12" md="6">
      <v-switch v-model="job.is_featured" label="Featured?"></v-switch>
    </v-col>
    
    <v-col cols="12" sm="12" md="6">
      <v-autocomplete
        v-model="job.organization_id"
        label="Organization"
        :items="organizations"
        item-text="name"
        item-value="id"
        clearable
        required
      ></v-autocomplete>
    </v-col>
    
    <v-col cols="12" sm="12" md="6">
      <v-autocomplete
        v-model="job.category_id"
        label="Category"
        :items="categories"
        item-text="title"
        item-value="id"
        clearable
        required
      ></v-autocomplete>
    </v-col>
    
    <v-col cols="12" sm="12" md="12">
      <v-text-field
        v-model="job.title"
        label="Title"
        required
      ></v-text-field>
    </v-col>
    
    <v-col cols="12" sm="12" md="12">
      <v-text-field
        v-model="job.alias"
        label="Alias"
        hint="No spaces or special characters, e.g. my-job"
        required
      ></v-text-field>
    </v-col>
    
    <v-col cols="12" sm="12" md="6">
      <v-text-field
        v-model="job.job_link"
        required
        label="Link to job"
        prepend-icon="mdi-link"
        placeholder="https://yourcompany.com/example_job or youremail@yourcompany.com"
        hint="Add an email to receive emails with resumes"
        persistent-hint
      ></v-text-field>
    </v-col>
    
    <v-col cols="12" sm="12" md="6">
      <v-select
        v-model="job.remote_type"
        :items="['Remote','In-person','Hybrid']"
        label="Remote Work?"
        clearable
      ></v-select>
    </v-col>
    
    <v-col cols="12" sm="12" md="6">
      <v-select
        v-model="job.contract_type"
        :items="contractItems"
        label="Contract Type"
        clearable
      ></v-select>
    </v-col>
  </v-row>
</v-container>
      <v-container>
  <v-row>
    <v-col cols="12" sm="12" md="12">
      <p>Description*</p>
        <ckeditor 
          :editor="editor" 
          v-model="job.description"
          :config="editorConfig"
        ></ckeditor>
      <br/>
      <br/>
      <v-btn @click="job.description = ''">Clear</v-btn>
      <v-btn @click="suggestImprovements" :loading="loadingSuggestions">Suggest Improvements</v-btn>
    </v-col>
  </v-row>
  
  <v-row v-if="improvedDescription">
    <v-col cols="12" sm="12" md="12">
      <p>Improved Description:</p>
      <v-card>
        <v-card-text v-html="improvedDescription"></v-card-text>
      </v-card>
      <v-btn @click="applyImprovedDescription" color="primary" class="mt-2">Apply Improved Description</v-btn>
    </v-col>
  </v-row>
</v-container>  
<v-container>
  <v-row>
    <v-col cols="12" sm="12">
      <p class="text-h5">Address</p>
    </v-col>
    
    <v-col cols="12" sm="12" md="6">
      <v-select
        v-model="job.region"
        label="Region"
        :items="regions"
        clearable
      ></v-select>
    </v-col>
    
    <v-col cols="12" sm="12" md="6">
      <v-text-field
        v-model="job.address"
        label="Street"
        prepend-icon="mdi-map"
      ></v-text-field>
    </v-col>
    
    <v-col cols="12" sm="12" md="6">
      <v-text-field
        v-model="job.city"
        label="City"
        prepend-icon="mdi-map"
      ></v-text-field>
    </v-col>
    
    <v-col cols="12" sm="12" md="6">
      <v-text-field
        v-model="job.postal_code"
        label="Postal Code"
        prepend-icon="mdi-map"
      ></v-text-field>
    </v-col>
  </v-row>
  
  <v-row>
    <v-col cols="12" sm="12">
      <p class="text-h5">Experience</p>
    </v-col>
    
    <v-col cols="12" sm="12" md="4">
      <v-select 
        label="Minimum Experience (years)" 
        :items="experienceItems" 
        v-model="job.minimum_experience" 
        clearable
      ></v-select>
    </v-col>
    
    <v-col cols="12" sm="12" md="4">
      <v-select 
        label="Maximum Experience (years)" 
        :items="experienceItems" 
        v-model="job.maximum_experience" 
        clearable
      ></v-select>
    </v-col>
    
    <v-col cols="12" sm="12" md="4">
      <v-select 
        label="Job Level" 
        :items="careerLevelItems" 
        v-model="job.career_level" 
        clearable
      ></v-select>
    </v-col>
  </v-row>
  
  <v-row>
    <v-col cols="12" sm="12">
      <p class="text-h5">Salary</p>
    </v-col>
    
    <v-col cols="12" sm="12" md="4">
      <v-text-field 
        number 
        minimum="0" 
        label="Minimum Salary" 
        v-model="job.minimum_salary" 
        prefix="€"
      ></v-text-field>
    </v-col>
    
    <v-col cols="12" sm="12" md="4">
      <v-text-field 
        number 
        minimum="0" 
        label="Maximum Salary" 
        v-model="job.maximum_salary" 
        prefix="€"
      ></v-text-field>
    </v-col>
    
    <v-col cols="12" sm="12" md="4">
      <v-select 
        label="Salary Type" 
        :items="salaryTypeItems" 
        v-model="job.salary_type" 
        clearable
      ></v-select>
    </v-col>
  </v-row>
  <!-- Add this after the Salary section, before the closing v-container tag -->
<v-row>
  <v-col cols="12" sm="12">
    <p class="text-h5">Publishing Dates</p>
  </v-col>
  
  <v-col cols="12" sm="12" md="6">
    <v-menu
      ref="start_publishing_menu"
      v-model="start_publishing_menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="job.start_publishing"
          label="Start publishing on"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="job.start_publishing"
        min="2023-01-01"
      ></v-date-picker>
    </v-menu>
  </v-col>
  
  <v-col cols="12" sm="12" md="6">
    <v-menu
      ref="stop_publishing_menu"
      v-model="stop_publishing_menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="job.stop_publishing"
          label="Stop publishing on"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="job.stop_publishing"
        min="2023-01-01"
      ></v-date-picker>
    </v-menu>
  </v-col>
</v-row>

<v-row>
  <v-col cols="12" sm="12">
    <p class="text-h5">Tags</p>
  </v-col>
  
  <v-col cols="12" sm="12" md="6">
    <v-text-field v-model="newtag" label="New Tag"></v-text-field>
    <v-btn @click="addTag">Add</v-btn>
    <v-btn @click="suggestTags">Suggest Tags</v-btn>
  </v-col> 
  
  <v-col cols="12" sm="12" md="6">
    <v-select 
      chips 
      v-model="job.tags" 
      :items="job.tags" 
      label="Tags" 
      multiple 
      clearable
    ></v-select>
  </v-col> 
</v-row>

<v-row>
  <v-col cols="12" sm="12">
    <p class="text-h5">Courses</p>
  </v-col>
  
  <v-col cols="12" sm="12" md="6">
    <v-autocomplete
      v-model="newcourse"
      :items="newcourseitems"
      :search-input.sync="searchCourses"
      color="white"
      hide-no-data
      hide-selected
      label="Find a Course"
      placeholder="Start typing to Search"
      prepend-icon="mdi-database-search"
      return-object
    ></v-autocomplete>
    <v-btn @click="addCourse">Add</v-btn>
    <v-btn @click="suggestCourses">Suggest Courses</v-btn>
  </v-col> 
  
  <v-col cols="12" sm="12" md="12">
    <v-simple-table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Title</th>
          <th>Organization</th>
          <th>Status</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="c in job.courses" :key="c.value+'_rowkey'">
          <td>{{ c.course.id }}</td>
          <td>{{ c.course.title }}</td>
          <td>{{ c.org.name }}</td>
          <td>{{ c.course.status }}</td>
          <td><v-icon @click="removeCourse(c)">mdi-delete</v-icon></td>
        </tr>
      </tbody>
    </v-simple-table> 
  </v-col> 
</v-row>
</v-container>  
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveJob" :loading="loading">
            Save Changes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue'
import Layout from '@/Shared/VuetifyAdminLayout'
import axios from 'axios'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  props: {
    job_id: Number,
    organizations: Array,
    categories: Array,
    regions: Array,
    // It's better to handle errors within the component state rather than as props
    // unless they are coming from a server-side Inertia response on initial load.
    // errors: Object 
  },
  components: {
    Head,
    Link,
    ckeditor: CKEditor.component
  },
  layout: Layout,
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        // Your CKEditor configuration
      },
      // State for any validation errors from the server
      errors: null,
      // The main job object, mirroring the structure from your working component
      job: {
        id: null,
        title: "",
        organization_id: null,
        category_id: null,
        alias: "",
        job_link: "",
        description: "",
        status: false,
        is_featured: false,
        address: "",
        city: "",
        region: "",
        country: "IE",
        postal_code: "",
        minimum_experience: null,
        maximum_experience: null,
        minimum_salary: null,
        maximum_salary: null,
        salary_type: null,
        career_level: null,
        start_publishing: null,
        stop_publishing: null,
        remote_type: '',
        tags: [],
        courses: [],
        // These fields were missing but are used in API calls from the working file
        tag_strings: [],
        courseList: []
      },
      // Loading states
      loading: false, // For initial job load
      loadingSave: false, // For the save button
      loadingSuggestions: false,
      
      // UI Control
      improvedDescription: null,
      start_publishing_menu: false,
      stop_publishing_menu: false,
      
      // Tag and Course management
      newtag: "",
      newcourse: null,
      newcourseitems: [],
      searchCourses: null,
      
      // Items for select/autocomplete fields, as seen in the working component
      experienceItems: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      careerLevelItems: ['Student (Undergrad)', 'Student (Graduate)', 'Entry level', 'Experienced', 'Manager', 'Executive', 'Senior Executive'],
      salaryTypeItems: ['Hourly', 'Weekly', 'Monthly', 'Yearly'],
      contractItems: ['Full-time', 'Part-time', 'Contract', 'Returnships', 'Volunteer', 'Flexible'],
    }
  },
  watch: {
    // Watcher to search for courses as the user types
    searchCourses(val) {
      if (val && val.length > 1) {
        this.searchCoursesByName(val);
      }
    }
  },
  mounted() {
    // Load the job data when the component is mounted
    if (this.job_id) {
        this.loadJob();
    }
  },
  methods: {
    /**
     * Fetches the job details from the server.
     * This is based on the `edit(id)` method from your working component.
     */
    loadJob() {
      this.loading = true;
      axios.get(`/admin/jobs/get/${this.job_id}`)
        .then((response) => {
          if (response && response.data) {
            this.job = response.data;
            
            // --- Data Normalization based on working component ---
            // The working component expects `tags` to be populated from `tag_strings`
            this.job.tags = response.data.tag_strings || [];
            
            // The working component expects `courses` to be populated from `courseList`
            this.job.courses = response.data.courseList || [];

            // Ensure booleans are correctly typed
            this.job.status = !!response.data.status;
            this.job.is_featured = !!response.data.is_featured;

            // Clean up description
            this.job.description = this.job.description ? this.job.description.replace("/>\s+</", "><") : "";
          }
        })
        .catch(error => {
          console.error('Error loading job:', error);
          // You could set an error message here to display to the user
          this.errors = [["Failed to load job data."]];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * Saves the updated job details.
     * This logic is adapted from `saveEditDialog()` in your working component.
     */
    saveJob() {
      this.loadingSave = true;
      this.errors = null; // Clear previous errors

      const formData = new FormData();
      
      // Append all job fields to FormData
      Object.keys(this.job).forEach(key => {
          // FormData handles null/undefined values, but let's ensure they are sent as empty strings if needed
          const value = this.job[key] === null ? '' : this.job[key];
          formData.append(key, value);
      });

      // **FIXED**: Correctly format `courses` and `tags` as expected by the backend.
      // The working file sends courses as a comma-separated string of IDs.
      if (this.job.courses && this.job.courses.length) {
        formData.set('courses', this.job.courses.map(c => c.value).join(','));
      } else {
        formData.set('courses', '');
      }
      
      // The working file sends tags as a comma-separated string.
      if (this.job.tags && this.job.tags.length) {
        formData.set('tags', this.job.tags.join(','));
      } else {
        formData.set('tags', '');
      }

      axios.post("/admin/jobs/update", formData)
        .then((response) => {
            console.log('got response', response);
          if (response.status === 200 && response.data == 1) {
            // Redirect on success
            this.$inertia.visit('/admin/jobs', { with: { success: 'Job updated successfully!' } });
          } else {
            // Handle unexpected success response
            this.errors = [[response.data.message || 'An unknown error occurred during update.']];
          }
        })
        .catch(error => {
          console.error('Error saving job:', error.response);
          if (error.response && error.response.data && error.response.data.errors) {
            // Set validation errors to be displayed in the form
            this.errors = Object.values(error.response.data.errors);
          } else {
            this.errors = [['Failed to save the job. Please try again.']];
          }
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    
    /**
     * Suggests improvements for the job description.
     * **FIXED**: Aligned with `/api/admin/improveDescription` from the working file.
     */
    suggestImprovements() {
      if (!this.job.description) {
        alert('Please add a description first');
        return;
      }
      this.loadingSuggestions = true;
      axios.post('/api/admin/improveDescription', {
        description: this.job.description
      })
        .then(response => {
          // **FIXED**: The response key is `improvedDescription`
          this.improvedDescription = response.data.improvedDescription;
        })
        .catch(error => {
          console.error('Error suggesting improvements:', error);
          alert('Failed to get suggestions. Please try again.');
        })
        .finally(() => {
          this.loadingSuggestions = false;
        });
    },

    applyImprovedDescription() {
      if (this.improvedDescription) {
        this.job.description = this.improvedDescription;
        this.improvedDescription = null;
      }
    },

    /**
     * Suggests tags based on job content.
     * **FIXED**: Aligned with `/admin/jobs/suggestTags` from the working file.
     */
    suggestTags() {
      const formData = new FormData();
      Object.keys(this.job).forEach(key => formData.append(key, this.job[key]));

      axios.post("/admin/jobs/suggestTags", formData)
        .then((response) => {
          if (response && response.data) {
            // Merge new tags with existing ones, avoiding duplicates
            this.job.tags = [...new Set([...this.job.tags, ...response.data])];
          }
        })
        .catch(error => {
          console.error('Error suggesting tags:', error);
          alert('Failed to get tag suggestions.');
        });
    },

    addTag() {
      if (this.newtag && !this.job.tags.includes(this.newtag)) {
        this.job.tags.push(this.newtag);
        this.newtag = "";
      }
    },

    removeTag(tagToRemove) {
        this.job.tags = this.job.tags.filter(tag => tag !== tagToRemove);
    },

    /**
     * Searches for courses by name.
     * **FIXED**: Aligned with `/admin/courses/searchByTitle` from the working file.
     */
    searchCoursesByName(query) {
      const formData = new FormData();
      formData.append('searchString', query);
      axios.post("/admin/courses/searchByTitle", formData)
        .then((response) => {
          if (response && response.data) {
            // The working file simply assigns the response, implying it's already formatted.
            this.newcourseitems = response.data;
          }
        })
        .catch(error => {
          console.error('Error searching courses:', error);
        });
    },
    
    /**
     * Suggests courses based on job content.
     * **FIXED**: Aligned with `/admin/jobs/suggestCourses` from the working file.
     */
    suggestCourses() {
      const formData = new FormData();
      Object.keys(this.job).forEach(key => formData.append(key, this.job[key]));

      axios.post("/admin/jobs/suggestCourses", formData)
        .then((response) => {
          if (response && response.data) {
            // Merge new courses, ensuring no duplicates (by stringifying/parsing objects)
            let combined = [...this.job.courses, ...response.data];
            let unique = [...new Map(combined.map(item => [item['value'], item])).values()];
            this.job.courses = unique;
          }
        })
        .catch(error => {
          console.error('Error suggesting courses:', error);
          alert('Failed to get course suggestions.');
        });
    },

    addCourse() {
      if (this.newcourse && !this.job.courses.some(c => c.value === this.newcourse.value)) {
        this.job.courses.push(this.newcourse);
        this.newcourse = null; // Clear selection
        this.searchCourses = ''; // Clear search text
      }
    },

    removeCourse(courseToRemove) {
      this.job.courses = this.job.courses.filter(c => c.value !== courseToRemove.value);
    },
  }
}
</script>
